import { gql } from "@apollo/client";

export const GET_QUIZ_GROUP = gql`
  query ($quizGroup: ID!) {
    quizGroup(quizGroup: $quizGroup) {
      id
      name
      description
      context
      dueDate
      isPublished
      tags {
        id
        tag
      }
      ongoingJobs {
        id
        status
        progress
        message
        jobType {
          jobType
        }
      }
      schoolClass {
        id
        name
        official
        subject {
          id
          name
        }
        educationLevel {
          id
          level
        }
        yearGroup {
          id
          yearGroup
          educationLevel {
            id
            level
          }
        }
      }
      quizzes {
        id
        quizQuestions {
          id
          question {
            id
            questionText
            questionType
            isPublished
            isComplete
            tags {
              id
              tag
            }
            options {
              id
              text
              isCorrect
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_QUIZ_GROUPS = gql`
  query (
    $selectedStatus: String
    $schoolClass: ID
    $searchString: String
    $isPublished: Boolean
    $showAllClasses: Boolean
    $first: Int
    $after: String
  ) {
    quizGroups(
      schoolClass: $schoolClass
      isPublished: $isPublished
      searchString: $searchString
      selectedStatus: $selectedStatus
      showAllClasses: $showAllClasses
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          name
          canAccessOnTier
          description
          context
          isPublished
          status
          dueDate
          tags {
            id
            tag
          }
          schoolClass {
            id
            name
            academicYear {
              id
              name
            }
            yearGroup {
              id
              yearGroup
              educationLevel {
                id
                level
              }
            }
            subject {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const CHECK_FOR_EXISTING_RESPONSE = gql`
  query checkForExistingResponses(
    $quizGroup: ID!
    $identifier: ID
    $teacherView: Boolean
  ) {
    existingQuizResponses(
      quizGroup: $quizGroup
      identifier: $identifier
      teacherView: $teacherView
    ) {
      responses
      quiz {
        id
      }
      disableChangeResponses
      showMarks
    }
  }
`;

export const GET_QUIZ_GROUP_SUBMISSIONS = gql`
  query ($quizGroup: ID!) {
    quizGroupSubmissions(quizGroup: $quizGroup) {
      student {
        id
        pseudonymisedAt
        identifier
      }
      submitted
      percentage
      submittedAt
    }
  }
`;

export const GET_QUIZ_QLA = gql`
  query ($quiz: ID!) {
    quizQuestionLevelAnalysis(quiz: $quiz) {
      questionId
      questionText
      questionType
      percentageCorrect
      percentageIncorrect
      options {
        id
        option
        text
        selectedCount
        isCorrect
      }
    }
  }
`;
